import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'Section heading',
    defaultMessage: 'Capçalera de secció',
  },
  headingTitle: {
    id: 'Heading title',
    defaultMessage: 'Títol',
  },
});

export const SectionHeadingSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['title'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.headingTitle),
      widget: 'text',
    },
  },
  required: ['title'],
});
